import React from "react";

const LogOutButton = ({ onClick }) => {
  return (
    <button
      className="button"
      onClick={onClick}
    >
      Log out
    </button>
  );
};

export default LogOutButton;
